import template from './kform-component-tooltip.html';

const kformComponentTooltipDirective = () => ({
	restrict: 'E',
	replace:  true,
	scope:    false,
	template,
});

export default kformComponentTooltipDirective;
